module.exports = __webpack_public_path__ + "static/Sun-Dried-Kalamata-Olives-Unpitted-Marinated-b856e7aa662d5123a0ceac7ca27b18da.png";